@use '/src/shared/assets/break-points' as *;

.items {
    background: white;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    flex: 1 0 auto;
    padding: 1rem;

    .item {
        display: flex;
        gap: 1rem;
        justify-content: space-between;

        &:not(:last-of-type) {
            border-bottom: 1px solid rgb(230, 230, 230);
            padding-bottom: 1rem;

            @media (max-width:  $xs){
                padding-bottom: 0.5rem;
            }
        }

        .label {
            font-weight: 600;
            text-align: left;
        }

        .content {
            text-align: right;
            hyphens: auto;
        }

        &.wrap {
            flex-direction: column;
            gap: 1rem;
            align-items: start;

            .content {
                text-align: left;
            }
        }

        @media (max-width:  $xs) {
            flex-direction: column;
            gap: 0.5rem;
            align-items: start;

            .content {
                text-align: left;
            }
        }
    }
}

